<template>
  <div class="portal-layout">
    <!-- 顶部导航 -->
    <header class="portal-header">
      <div class="header-inner">
        <div class="logo-area" @click="goHome">
          <img :src="logo" alt="logo" class="logo-img" />
          <span class="logo-text">小程童信奥</span>
        </div>
        <nav class="nav-area">
          <router-link to="/portal/home" class="nav-item" :class="{ active: isActive('/portal/home') }">首页</router-link>
          <span class="nav-item" :class="{ active: isShopActive }" @click="goShopList">课程商城</span>
          <span class="nav-item" :class="{ active: isProblemActive }" @click="goProblemList">在线判题</span>
          <span class="nav-item" :class="{ active: isActive('/portal/customize/exam') }" @click="goExam">在线考试</span>
          <!-- 官网静态站点（public/site），独立页面，新窗口打开 -->
          <a href="/site/index.html" target="_blank" rel="noopener" class="nav-item">官方网站</a>
        </nav>
        <div class="user-area">
          <template v-if="member">
            <span class="user-name user-center-link" @click="goUserCenter">{{ member.custName || member.mobile }}</span>
            <el-button type="text" class="logout-btn" @click="handleLogout">退出</el-button>
          </template>
          <template v-else>
            <el-button type="text" class="login-btn" @click="goLogin">登录 / 注册</el-button>
          </template>
        </div>
      </div>
    </header>

    <!-- 主体内容 -->
    <main class="portal-main">
      <slot></slot>
    </main>

    <!-- 页脚 -->
    <footer class="portal-footer">
      <div class="footer-inner">
        <div class="footer-brand">
          <img :src="logo" alt="logo" class="footer-logo" />
          <div class="footer-brand-text">
            <p class="footer-name">小程童信奥</p>
            <p class="footer-slogan">青少年信息学奥林匹克竞赛学习平台</p>
          </div>
        </div>
        <div class="footer-links">
          <span class="footer-link" @click="goShopList">课程商城</span>
          <span class="footer-link" @click="goProblemList">在线判题</span>
          <span class="footer-link" @click="goExam">在线考试</span>
          <a href="/site/index.html" target="_blank" rel="noopener" class="footer-link">官方网站</a>
        </div>
      </div>
      <div class="footer-copy">
        <span>© {{ currentYear }} 小程童信奥 · 专注青少年信息学竞赛教学与训练</span>
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener" class="footer-icp">苏ICP备2024151943号-2</a>
      </div>
    </footer>
  </div>
</template>
<script>
import api from "@/common/api";
import storage from "@/common/storage.js";
export default {
  name: 'PortalLayout',
  data() {
    return {
      logo: require('@/assets/logo.png'),
      member: null
    }
  },
  computed: {
    // 判题相关页面（列表/详情/提交详情）都视为「在线判题」激活
    isProblemActive() {
      return this.$route.path.indexOf('/portal/problem') === 0;
    },
    // 商城相关页面（列表/详情/购物车/收藏/联系）都视为「课程商城」激活
    isShopActive() {
      return this.$route.path.indexOf('/portal/shop') === 0;
    },
    currentYear() {
      return new Date().getFullYear();
    }
  },
  created() {
    this.queryMember();
  },
  methods: {
    isActive(path) {
      return this.$route.path === path;
    },
    goHome() {
      if (this.$route.path === '/portal/home') return;
      this.$router.push('/portal/home').catch(() => {});
    },
    goLogin() {
      if (this.$route.name === 'PortalLogin') return;
      this.$router.push({ name: 'PortalLogin', query: { redirect: this.$route.fullPath } }).catch(() => {});
    },
    goExam() {
      // 已在考试列表页时不重复跳转，避免 NavigationDuplicated
      if (this.$route.path === '/portal/customize/exam') return;
      // 未登录时直接跳登录页，登录后回跳到在线考试列表
      if (!storage.getString('portalMember')) {
        this.$router.push({ name: 'PortalLogin', query: { redirect: '/portal/customize/exam' } }).catch(() => {});
        return;
      }
      this.$router.push('/portal/customize/exam').catch(() => {});
    },
    goProblemList() {
      if (this.$route.path === '/portal/problem/list') return;
      // 未登录时直接跳登录页，登录后回跳到题目列表
      if (!storage.getString('portalMember')) {
        this.$router.push({ name: 'PortalLogin', query: { redirect: '/portal/problem/list' } }).catch(() => {});
        return;
      }
      this.$router.push('/portal/problem/list').catch(() => {});
    },
    // 课程商城允许匿名浏览，登录后可在详情页收藏/加购
    goShopList() {
      if (this.$route.path === '/portal/shop/list') return;
      this.$router.push('/portal/shop/list').catch(() => {});
    },
    goUserCenter() {
      if (this.$route.path === '/portal/user/center') return;
      this.$router.push('/portal/user/center').catch(() => {});
    },
    // 查询当前登录会员
    // PortalLayout 被每个门户页面各自包裹渲染，路由切换时会重新 created，
    // 因此这里优先读缓存渲染，仅在无缓存时才请求接口，避免每次切页都重复请求。
    // 退出登录时 handleLogout 会主动清缓存，不会出现脏数据。
    queryMember() {
      let cached = storage.getString('portalMember');
      if (cached) {
        try {
          this.member = JSON.parse(cached);
          return;
        } catch (e) {
          this.member = null;
          storage.removeString('portalMember');
        }
      }
      // 已确认过未登录（如匿名访问后接口返回401），本次会话内不再重复请求
      if (storage.getString('portalNoLogin') === '1') {
        return;
      }
      api.current_member().then((r) => {
        if (r.data.code === "200" && r.data.data) {
          this.member = r.data.data;
          storage.setString('portalMember', JSON.stringify(r.data.data));
          storage.removeString('portalNoLogin');
        } else {
          // 接口正常返回但无登录数据，标记为未登录
          storage.setString('portalNoLogin', '1');
        }
      }).catch(() => {
        // 未登录时接口返回401，标记后不再重复请求
        storage.setString('portalNoLogin', '1');
      });
    },
    handleLogout() {
      api.logout().then(() => {
        this.member = null;
        storage.removeString('portalMember');
        storage.removeString('portalNoLogin');
        this.$message.success('已退出登录');
        this.$router.push('/portal/home').catch(() => {});
      });
    }
  }
};
</script>
<style scoped>
.portal-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #F4F6FA;
}

/* ---------- 顶部导航 ---------- */
.portal-header {
  background-color: #fff;
  position: sticky;
  top: 0;
  z-index: 100;
  /* 顶部一条品牌渐变细线，比阴影更有门户辨识度 */
  border-bottom: 1px solid #E4E8EF;
  box-shadow: 0 2px 12px rgba(31, 39, 51, 0.05);
}
.portal-header::before {
  content: '';
  display: block;
  height: 3px;
  background: linear-gradient(90deg, #2B7EF5 0%, #5B9CF8 45%, #FF8A47 100%);
}
.header-inner {
  max-width: 1200px;
  margin: 0 auto;
  height: 66px;
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.logo-area {
  display: flex;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
}
.logo-img {
  width: 38px;
  height: 38px;
  margin-right: 10px;
  border-radius: 8px;
}
.logo-text {
  font-size: 19px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #1F2733;
}
/* 导航：居中摆放，视觉重心更稳 */
.nav-area {
  flex: 1;
  display: flex;
  justify-content: center;
  margin: 0 20px;
}
.nav-item {
  position: relative;
  margin: 0 13px;
  font-size: 15px;
  color: #4A5568;
  text-decoration: none;
  padding: 6px 0;
  transition: color 0.25s ease;
  cursor: pointer;
  white-space: nowrap;
}
.nav-item::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 0;
  height: 2px;
  background-color: #2B7EF5;
  border-radius: 1px;
  transform: translateX(-50%);
  transition: width 0.25s ease;
}
.nav-item:hover {
  color: #2B7EF5;
}
.nav-item:hover::after {
  width: 100%;
}
.nav-item.active {
  color: #2B7EF5;
  font-weight: 600;
}
.nav-item.active::after {
  width: 100%;
}

/* ---------- 用户区 ---------- */
.user-area {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.user-name {
  font-size: 14px;
  color: #4A5568;
}
/* 登录后：头像圆点 + 昵称，做成胶囊按钮 */
.user-center-link {
  display: inline-flex;
  align-items: center;
  margin-right: 12px;
  padding: 5px 14px 5px 5px;
  border-radius: 18px;
  background-color: #F4F6FA;
  cursor: pointer;
  transition: all 0.25s ease;
}
.user-center-link::before {
  content: '';
  width: 24px;
  height: 24px;
  margin-right: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background: linear-gradient(135deg, #2B7EF5 0%, #5B9CF8 100%);
}
.user-center-link:hover {
  background-color: #EAF3FE;
  color: #2B7EF5;
}
.logout-btn,
.login-btn {
  font-size: 14px;
  color: #2B7EF5;
  font-weight: 500;
}
.login-btn {
  padding: 8px 20px;
  border: 1px solid #2B7EF5;
  border-radius: 18px;
  transition: all 0.25s ease;
}
.login-btn:hover {
  background-color: #2B7EF5;
  color: #fff !important;
}

/* ---------- 主体 ---------- */
.portal-main {
  flex: 1;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 28px 20px 40px;
  box-sizing: border-box;
}

/* ---------- 页脚 ---------- */
.portal-footer {
  background-color: #1F2733;
  color: #A8B0BA;
  padding: 32px 20px 20px;
}
.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.footer-brand {
  display: flex;
  align-items: center;
}
.footer-logo {
  width: 40px;
  height: 40px;
  margin-right: 12px;
  border-radius: 8px;
}
.footer-brand-text {
  display: flex;
  flex-direction: column;
}
.footer-name {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
}
.footer-slogan {
  margin: 4px 0 0 0;
  font-size: 12px;
  color: #8A94A1;
}
.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 22px;
}
.footer-link {
  font-size: 13px;
  color: #A8B0BA;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.25s ease;
}
.footer-link:hover {
  color: #5B9CF8;
}
.footer-copy {
  max-width: 1200px;
  margin: 16px auto 0;
  font-size: 12px;
  color: #78838F;
}
/* 备案号链接 */
.footer-icp {
  margin-left: 12px;
  color: #78838F;
  text-decoration: none;
  transition: color 0.25s ease;
}
.footer-icp:hover {
  color: #5B9CF8;
}

/* ---------- 窄屏 ---------- */
@media (max-width: 1080px) {
  .nav-item {
    margin: 0 9px;
    font-size: 14px;
  }
  .logo-text {
    display: none;
  }
}
@media (max-width: 900px) {
  .header-inner {
    flex-wrap: wrap;
    height: auto;
    padding: 12px 16px;
  }
  .nav-area {
    order: 3;
    width: 100%;
    margin: 10px 0 0 0;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .nav-item {
    margin: 4px 14px 4px 0;
  }
  .footer-inner {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
